import { GetAccountCreditByCoreIdQuery } from "@/api/hasura/generated/graphql"
import {
  IAccountCreditRaw,
  AccountCreditParser,
} from "@/models/accountCredit/accountCredit.parser"
import { AccountCredit } from "@/models/accountCredit/accountCredit"
import { HasuraQueries } from "@/api/hasura/queries"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { useQuery, useMutation } from "@/api/utils/useQuery"
import { MutationResult, QueryResult } from "@/api/utils/types"
import { CreateAccountCreditRequest } from "@/api/backofficeRest/generated/model"

class AccountCreditServiceClass {
  createCredit(): MutationResult<CreateAccountCreditRequest> {
    return useMutation({
      ...BackofficeRestMutations.account.createCredit(),
      serializerFn: (data) => data,
    })
  }
  getCreditByCoreId(coreId: number): QueryResult<AccountCredit[]> {
    return useQuery({
      ...HasuraQueries.accountCredit.accountCreditByCoreId(coreId),
      useRawResponse: true,
      parserFn: (data?: GetAccountCreditByCoreIdQuery): AccountCredit[] => {
        if (!data) return []
        return data.account_credit.map((credit) => {
          return AccountCreditParser.toDomain(credit as IAccountCreditRaw)
        })
      },
      placeholderData: [],
    })
  }
}
export const AccountCreditService = new AccountCreditServiceClass()
